import React from "react";
import MultiplePizzas from "../assets/multiplePizzas.jpeg";
import "../styles/About.css";
function About() {
  return (
    <div className="about">
      <div
        className="aboutTop"
        style={{ backgroundImage: `url(${MultiplePizzas})` }}
      ></div>
      <div className="aboutBottom">
        <h1> ABOUT US</h1>
        <p>
          Welcome to our pizza website, your one-stop-shop for ordering
          delicious pizza online! 
          <br /><br/>
          We are a team of passionate pizza lovers who
          believe that nothing brings people together quite like a hot, fresh
          pie. That's why we've dedicated ourselves to crafting the perfect
          pizza experience, from our homemade dough to our carefully selected
          toppings and sauces. 
          <br/><br/>
          Our menu features a wide range of pizza options,
          including classic favorites like pepperoni and cheese, as well as
          unique and flavorful creations like our BBQ chicken and pesto veggie
          pies. We also offer a variety of sides, salads, and desserts to
          complement your meal. 
        </p>
      </div>
    </div>
  );
}

export default About;
